module.exports = __webpack_public_path__ + "media/components/application/PaymentCard/icons/microchip-a9ab002017d7feaf843364566f318548.svg";